module.exports = __webpack_public_path__ + "media/images/icons/outlined/build-56bf5a92b9b84a044d6e52b8f464f772.svg";